import React, { useMemo } from 'react'

import CustomizeEmbed from 'Pods/LazyLoaded/ShareModal/Components/CustomizeEmbed'
import EmbedSection from 'Pods/LazyLoaded/ShareModal/Components/EmbedSection'
import Preview from 'Pods/LazyLoaded/ShareModal/Components/Preview'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { buildSharedRunPathname } from 'Pods/ThreeDStudio/Hooks/buildSharedRunPathname'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function ThreeDStudioShareContent() {
  const t = useTranslation()
  const pageConfig = usePageConfig()
  const sharerUsername = pageConfig?.currentUserUsername || ''

  const runId = useThreeDStudioStore(state => state.ui?.openedModel?.id)
  const runSlug = useThreeDStudioStore(state => state.ui?.openedModel?.slug)
  const runTitle = useThreeDStudioStore(
    state => state.ui?.openedModel?.title ?? state.ui?.openedModel?.prompt ?? ''
  )

  const embedUrl = useMemo(
    () => `${window.location.origin}/embed/ai/${runId}`,
    [runId]
  )

  // Only the persisted `slug` resolves server-side (Run#assign_slug! appends a random
  // token); a title+id URL 404s on both the SSR lookup and the community-models endpoint.
  const shareUrl = useMemo(
    () => `${window.location.origin}${buildSharedRunPathname({ id: runId, slug: runSlug, title: runTitle })}`,
    [runId, runSlug, runTitle]
  )

  return (
    <EmbedSection
      shareUrl={shareUrl}
      renderCustomize={(settings, onSettingsChange) => (
        <CustomizeEmbed
          embedUrl={embedUrl}
          embedButtonLabel={t('shared.shareContent.embedButtonLabel')}
          sharerUsername={sharerUsername}
          showRating={false}
          settings={settings}
          onSettingsChange={onSettingsChange}
        />
      )}
      renderPreview={(settings) => (
        <Preview
          settings={settings}
          sharerUsername={sharerUsername}
          embedUrl={embedUrl}
        />
      )}
    />
  )
}

export default ThreeDStudioShareContent
